if (typeof AddOnsSingleWarranty !== 'function') {
    class AddOnsSingleWarranty extends HTMLElement {
        constructor() {
            super();
            this.optionButtons = this.querySelectorAll('[data-addons-warranty]');

            if (this.optionButtons) {
                this.optionButtons.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const productIde = button.getAttribute('data-value');
                        const datafor = button.getAttribute('data-for');
                        let dataP = button.getAttribute("data-seek");
                        if (!button.classList.contains('active')) {

                            this.querySelectorAll('[data-addons-warranty]').forEach(ele => {
                                ele.classList.remove('active');
                            });
                            const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                            allInputs.forEach(ele => {
                                ele.remove();
                            })
                            button.classList.add('active');
                            if (dataP === null) {
                                dataP = 0;
                            }
                            this.handleAddAddons(productIde, datafor, dataP);
                        } else {
                            const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                            allInputs.forEach(ele => {
                                ele.remove();
                            })
                            console.log(productIde);
                            button.classList.remove('active');
                        }
                    })
                })
            }

        }
        handleAddAddons(ide, datafor, dataP) {
            if (ide) {
                const element = document.createElement('input');
                element.value = ide;
                element.type = 'hidden';
                element.name = 'id';
                element.setAttribute('data-for', datafor);
                element.setAttribute("data-seek", dataP)
                element.classList.add = 'addon_input';
                element.setAttribute('data-quantity', 1);
                const formContent = document.getElementById('bulk-add-to-cart');
                formContent.append(element);
            } else {
                document.querySelector(`input[data-for="${datafor}"]`)?.remove();
            }

            this.getFinalPrice();
        }

        getFinalPrice() {
            const elementsForm = document.querySelectorAll('input[data-seek]');
            let total = 0;
            elementsForm.forEach((e) => {
                if (e.getAttribute("data-seek") && e.getAttribute("data-seek") !== null) {
                    total += Number(e.getAttribute("data-seek"));
                }
            })
            const formattedNumber = (total / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
            document.getElementById('total_buy').innerHTML = formattedNumber;
            document.querySelectorAll('.total_buy_button').forEach((button) => {
                button.innerHTML = formattedNumber;
            });
        }
    }

    if (typeof customElements.get('addon-warranty') == 'undefined') {
        customElements.define('addon-warranty', AddOnsSingleWarranty);
    }
}
